import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';

import { buttonClassName, buttonStyles, type ButtonStyleOptions } from './buttonStyles';

export interface ButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>, Omit<ButtonStyleOptions, 'className'> {
  /** Shows a spinner and blocks interaction while an action is in flight. */
  isLoading?: boolean;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  children: ReactNode;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    variant,
    size,
    fullWidth,
    isLoading = false,
    leftIcon,
    rightIcon,
    className,
    disabled,
    type = 'button',
    children,
    ...props
  },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={buttonClassName({ variant, size, fullWidth, className })}
      disabled={disabled ?? isLoading}
      aria-busy={isLoading || undefined}
      {...props}
    >
      {isLoading ? <span className={buttonStyles.spinner} aria-hidden="true" /> : leftIcon}
      {children}
      {rightIcon}
    </button>
  );
});
